module.exports = __webpack_public_path__ + "static/media/logo_argentina-blanco.3e9035ff.svg";